var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vIf())?_c('button',{attrs:{"type":"button","disabled":_vm.disabled() || _vm.loading},on:{"click":_vm.action}},[(_vm.loading)?[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v("\n\t\tEnviando\n\t")]:[_c('i',{class:_vm.icon}),_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f17fe9b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/models/create-form/components/action-button.vue
// module id = null
// module chunks = 